// import Tabs from '../modules/Tabs'

export interface VueSettingsInterface {
  common: {
    basePath: string,
    language: string,
  },
  siteName: string,
  domain: string,
  member: {
    pageUrl: {
      myPage: string,
      mnTop: string,
      stopMailDeliver: string,
      systemError: string,
      sessionError: string,
      termsOfUse: string,
      privacyPolicy: string,
      precautionsForUse: string,
      aboutSMC: string,
      readBeforeRegist: string,
      withdrawalCompleted: string,
      logout: string,
    },
    recaptcha: {
      siteKey: string
    }
  }
}

const getVueSettings = function (): VueSettingsInterface {
  const element = document.querySelector('[data-drupal-selector="vue-settings-json"]')

  let settings = <VueSettingsInterface>{}
  if (element) {
    settings = <VueSettingsInterface>JSON.parse(element.innerHTML)
  }

  return settings
}

export default getVueSettings()
